import { http } from '@/utils/http'
import type { Response } from '@/types/http'
import type { AppReadVipMemberRes } from '@/types/vip'
import type { UserDTO } from '@/types/user'

/**
 * 注册
 */
export const apiRegister = async (data: object) => {
  return await http('/app-api/member/user/register', {
    method: 'post',
    body: data,
    msgType: 'dialog'
  })
}

/**
 * 发送短信验证码
 */
export const sendSMS = async (param: { mobile: string; area: string }) => {
  return await http<Response<boolean>>('/app-api/member/auth/sms-code', {
    method: 'post',
    body: param,
    noMsg: true
  })
}

/**
 * 校验手机号是否已注册
 */
export const checkMobileRegistered = async (param: { [key: string]: any }) => {
  return await http<Response<boolean>>('/app-api/member/auth/verify-mobile', {
    method: 'post',
    body: param,
    msgType: 'dialog'
  })
}

/**
 * 重置登录密码（无需旧密码）
 */
export const resetPassword = async (param: { password: string; code: string; mobile: string }) => {
  return await http<Response<boolean>>('/app-api/member/user/reset-password', {
    method: 'post',
    body: param,
    msgType: 'dialog'
  })
}

/**
 * 登录
 */
export const apiLogin = async (data: object) => {
  return await http('/app-api/member/auth/login', {
    method: 'post',
    body: data,
    msgType: 'dialog'
  }).then((res) => {
    return res.data
  })
}

/**
 * 退出登录
 */
export const apiAuthLogout = async () => {
  return await http<Response<boolean>>('/app-api/member/auth/logout', {
    method: 'post',
    body: {},
    noMsg: true
  })
}

/**
 * Firebase Google 登录
 */
export const apiFireBaseLogin = (token: string) => {
  return http<Response<{ accessToken: string }>>('/app-api/member/auth/firebase-login', {
    method: 'post',
    body: {
      socialType: 60,
      token,
      shareCode: localStorage.getItem('shareCode') || '',
      host: location.origin
    }
  })
}

/**
 * 会员VIP信息-查询
 * @returns
 */
export const getVipMemberInfo = async () => {
  return await http<Response<AppReadVipMemberRes>>('/app-api/member/vip-member/readVipMember', {
    method: 'post'
  })
}

/**
 * 查询用户信息
 */
export const apiUserGet = () => {
  return http<Response<UserDTO>>('/app-api/member/user/get', {
    method: 'post',
    body: {},
    noMsg: true
  })
}

/**
 * 修改真实姓名
 */
export const updateRealName = (realName: string) => {
  return http<Response<boolean>>('/app-api/member/user/update-name', {
    method: 'post',
    body: {
      realName
    }
  })
}

/**
 * 修改基本信息
 */
export const updateUserInfo = (body: { sex?: number; birthday?: string }) => {
  return http<Response<boolean>>('/app-api/member/user/update', {
    method: 'post',
    body
  })
}

/**
 * 修改用户手机
 */
export const updateMobile = (body: { code: string; mobile: string }) => {
  return http<Response<boolean>>('/app-api/member/user/update-mobile', {
    method: 'post',
    body
  })
}

// 修改登录密码
export function updateLoginPassword(body: {
  oldPassword: string
  newPassword: string
  confirmPassword: string
}) {
  return http<Response<boolean>>('/app-api/member/user/update-password', {
    method: 'post',
    body,
    noMsg: true
  })
}

// 设置支付密码
export function setWithdrawPassword(body: {
  // 登录密码
  loginPassword: string
  password: string
  confirmPassword: string
}) {
  return http<Response<boolean>>('/app-api/member/user/init-withdraw-password', {
    method: 'post',
    body,
    noMsg: true
  })
}

// 更新支付密码
export function updateWithdrawPassword(body: {
  oldPassword: string
  newPassword: string
  confirmPassword: string
}) {
  return http<Response<boolean>>('/app-api/member/user/update-withdraw-password', {
    method: 'post',
    body,
    noMsg: true
  })
}
